import { createGlobalStyle } from "styled-components";

// import { CryptoFont } from "../utils/fonts";
// ${CryptoFont};

const CryptoFontCSS = createGlobalStyle`
`;

export default CryptoFontCSS;
